(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/skeleton_desktop.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/skeleton_desktop.js');
(function(Backbone, _, svs) {
  'use strict';


  svs.matchen.views.Skeleton = Marionette.View.extend({
    regions: {
      regionStartPage: '.region-matchen-start-page',
      leftRegion: '.matchen-left-region',
      rightRegion: '.matchen-right-region',
      regionBetslip: '.region-betslip'
    },

    template: function(data) {
      return svs.matchen.templates.start(data);
    },

    addRegionStartPage: function(view) {
      this.showChildView('regionStartPage', view);
    },

    addLeftRegion: function(view) {
      this.showChildView('leftRegion', view);
    },

    addRightRegion: function(view) {
      this.showChildView('rightRegion', view);
    },

    addRegionBetslip: function(view) {
      this.showChildView('regionBetslip', view);
    }
  });
})(Backbone, _, svs);


 })(window);